export const THEME_COOKIE = 'theme';
